import React from 'react'
import Footer from '../components/website/Footer'
import Articles from './product/Articles'
const VendorHome = () => {
  return (
    <div className='vendor-home'>
      <Articles />
    </div>
  )
}

export default VendorHome
